import { Instagram, Mail, Phone, MapPin, MessageCircle } from "lucide-react";

export default function Footer({ content }) {
  const brand = content?.brand || {};
  const fc = content?.footer || {};

  return (
    <footer className="relative" data-testid="site-footer">
      <div className="ribbon-divider" />
      <div className="bg-stripes-blue-soft py-14 md:py-16 bg-noise">
        <div className="max-w-6xl mx-auto px-5 md:px-8 text-center">
          <div className="inline-block">
            <span className="title-balloon text-5xl md:text-7xl block leading-none" style={{ color: "var(--ff-text)" }}>
              {brand.name?.split(" ")[0] || "Fantastic"}
            </span>
            <span className="title-balloon text-4xl md:text-6xl block leading-none -mt-2" style={{ color: "var(--ff-peach)" }}>
              {brand.name?.split(" ").slice(1).join(" ") || "Fun"}
            </span>
          </div>

          <p className="font-body text-base md:text-lg mt-4 mb-8" style={{ color: "var(--ff-text-soft)" }}>
            {fc.tagline || brand.tagline}
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-10">
            {brand.instagram_url && (
              <a
                href={brand.instagram_url}
                target="_blank"
                rel="noreferrer"
                className="hover-zoom inline-flex items-center gap-2 bg-white px-5 py-3 rounded-full border-2 border-[var(--ff-peach)] font-display font-semibold text-sm"
                data-testid="footer-instagram"
              >
                <Instagram size={18} style={{ color: "var(--ff-peach)" }} />
                @{brand.instagram}
              </a>
            )}
            {brand.email && (
              <a
                href={`mailto:${brand.email}`}
                className="hover-zoom inline-flex items-center gap-2 bg-white px-5 py-3 rounded-full border-2 border-[var(--ff-sky)] font-display font-semibold text-sm"
                data-testid="footer-email"
              >
                <Mail size={18} style={{ color: "var(--ff-sky)" }} />
                {brand.email}
              </a>
            )}
            {brand.phone && (
              <a
                href={`https://wa.me/${brand.phone.replace(/\s/g, "")}`}
                target="_blank"
                rel="noreferrer"
                className="hover-zoom inline-flex items-center gap-2 bg-white px-5 py-3 rounded-full border-2 border-[var(--ff-peach)] font-display font-semibold text-sm"
                data-testid="footer-whatsapp"
              >
                <MessageCircle size={18} style={{ color: "var(--ff-peach)" }} />
                {brand.phone}
              </a>
            )}
          </div>

          <div className="flex items-center justify-center gap-2 font-body text-sm" style={{ color: "var(--ff-text-soft)" }}>
            <MapPin size={14} /> Portugal
          </div>

          <p className="mt-6 font-body text-xs md:text-sm opacity-70" style={{ color: "var(--ff-text-soft)" }}>
            {fc.rights || "© 2026 Fantastic Fun. Todos os direitos reservados."}
          </p>
        </div>
      </div>
    </footer>
  );
}
